import EventsSearchPillMenu from './EventsSearchPillMenu';

export default EventsSearchPillMenu;
